// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin`;

export const GetPostListApi = async (page = 1, limit = 100) => {
  try {
    const response = await fetch(`${url}/post-list?page=${page}&limit=${limit}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch post list.");
    }

    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

export const handleDeletePost = async (PostId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this Post?")) {
    try {
      const response = await fetch(`${url}/post`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete", _id: PostId }),
      });
      const data = await response.json();
      if (data.success) toast.success("Post deleted successfully");
      else toast.warning("Post deleted, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};
export const getPostByIdApi = async (id) => {
  try {
    const response = await fetch(`${url}/post`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body:  JSON.stringify({ action: "getById", _id: id }),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load recipe");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};


export const submitPostApi = async (postData) => {
  try {
    const response = await fetch(`${url}/post`, {
      method: "POST",
      body: postData,
    });

    const result = await response.json();

    if (result?.data && (response.status === 200 || response.status === 201)) {
      toast.success(postData._id ? "Post updated successfully" : "Post added successfully");
      return result;
    } else {
      toast.error(result.message || "Failed to save post");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the post");
    return null;
  }
};

export const getBlogByIdApi = async (id) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: JSON.stringify({ action: "getById", _id: id }) }),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load recipe");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
